var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkipIconImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skip-icon-img",
    transform: "translate(4689 5301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-skip-img",
    transform: "translate(-5067.9 -5517.784)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M5.9,9.926a1.479,1.479,0,0,1-.91-.313L.574,6.182A1.485,1.485,0,0,1,.558,3.85L4.973.325A1.485,1.485,0,1,1,6.826,2.645L3.884,4.994,6.811,7.269A1.485,1.485,0,0,1,5.9,9.926Z",
    transform: "translate(388.284 230.711) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336-2",
    "data-name": "Path 336",
    d: "M5.9,9.926a1.479,1.479,0,0,1-.91-.313L.574,6.182A1.485,1.485,0,0,1,.558,3.85L4.973.325A1.485,1.485,0,1,1,6.826,2.645L3.884,4.994,6.811,7.269A1.485,1.485,0,0,1,5.9,9.926Z",
    transform: "translate(394.886 230.711) rotate(180)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_624",
    "data-name": "Rectangle 624",
    width: 18,
    height: 18,
    transform: "translate(-4689 -5301)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipIconImg);
export default __webpack_public_path__ + "static/media/skip-icon-img.cdb91f51a24f5cd71302b73b94452f40.svg";
export { ForwardRef as ReactComponent };